<button mat-icon-button class="closer" [mat-dialog-close]="">
    <mat-icon mat-list-icon>close</mat-icon>
  </button>

<div class="search-multiple-dialog-wrapper">
    @if(searchBy === 'pMNumber') {
    <div class="search-multiple-content">
        <h1>Search PM#</h1>
        <h4>Add PM# separated by commas</h4>
        <textarea (input)="searchInput = $event.target.value" [value]="searchInput"  placeholder="Add multiple PM#"></textarea>
    </div>
    }
    @else if(searchBy === 'notificationNumber') {
    <div class="search-multiple-content">
        <h1>Search by Notification #</h1>
        <h4>Add Notification #s separated by commas</h4>
        <textarea (input)="searchInput = $event.target.value" [value]="searchInput" placeholder="Add multiple Notifications #s"></textarea>
    </div>
    }
    @else if(searchBy === 'jobAddress') {
    <div class="search-multiple-content">
        <h1>Search by Addresses</h1>
        <h4>Add Addresses separated by commas</h4>
        <textarea (input)="searchInput = $event.target.value" [value]="searchInput" placeholder="Add multiple Addresses"></textarea>
    </div>
    }
    @else if(searchBy === 'invoiceNumber') {
    <div class="search-multiple-content">
        <h1>Search by Invoices #</h1>
        <h4>Add Invoices #s separated by commas</h4>
        <textarea (input)="searchInput = $event.target.value" [value]="searchInput" placeholder="Add multiple Invoices #s"></textarea>
    </div>
    }
    <div class="dialog-actions">
        <button mat-raised-button color="warn" (click)="close()">Cancel</button>
        <button mat-raised-button color="primary" (click)="search()">Search</button>
    </div>
</div>